// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__Xfp5n","dark":"BaseLayout_dark__TCDkF","light":"BaseLayout_light__blYth"};